export default "{\n    \"emptyPlaceholder\": \"Click to select a client\",\n    \"searchPlaceholder\": \"Search by name\"\n}\n"